export default __webpack_public_path__ + "static/media/Tekmadev_Logo.cfb4c3f3.svg";